import { render, staticRenderFns } from "./pageTabs.vue?vue&type=template&id=4e81f4c4&scoped=true"
import script from "./pageTabs.vue?vue&type=script&lang=js"
export * from "./pageTabs.vue?vue&type=script&lang=js"
import style0 from "./pageTabs.vue?vue&type=style&index=0&id=4e81f4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e81f4c4",
  null
  
)

export default component.exports